import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { getData as apiGetData } from 'api/Api'
import { CancelError } from '@kanbo/api'
import {
  FormControl
} from 'react-bootstrap'
import UserPicker from 'components/UserPicker'
import Scrollbars from 'components/Scrollbars'
import InfiniteScroll from 'components/InfiniteScroll'
import classes from './KanBoUserPicker.module.scss'

const limit = 20

export class KanBoUserPicker extends React.Component {
  static propTypes = {
    addUsersArray: PropTypes.func.isRequired,
    ignoreUsers: PropTypes.array
  }

  state = {
    userIds: [],
    loading: false,
    loaded: false,
    cursor: null,
    keyword: ''
  }

  componentWillUnmount () {
    this.cancelFetchUsers()
  }

  setUserPickerRef = (ref) => {
    this.userPickerRef = ref
  }

  getSelectedUsers = () => {
    return this.userPickerRef.getSelectedUsers()
  }

  fetchUsers = () => {
    const { addUsersArray } = this.props
    const { keyword, cursor } = this.state

    this.setState({
      loading: true
    })

    const args = {
      limit,
      active: true
    }
    if (keyword) args.keyword = keyword
    if (cursor) args.cursor = cursor

    this.fetchUsersPromise = apiGetData('Users', args)
    this.fetchUsersPromise.then(({ Users, Cursor }) => {
      const newUsers = []
      const newUserIds = []

      Users.forEach(User => {
        newUsers.push({
          id: User.Id,
          name: User.Name,
          email: User.Email,
          profileKey: User.ProfileKey,
          licenseType: User.LicenseType,
          isActive: User.Active,
          isLoaded: true
        })

        newUserIds.push(User.Id)
      })

      addUsersArray(newUsers)

      this.setState((prevState) => ({
        userIds: [
          ...prevState.userIds,
          ...newUserIds
        ],
        loading: false,
        loaded: !Cursor,
        cursor: Cursor
      }))
    }).catch((error) => {
      if (!(error instanceof CancelError)) {
        throw error
      }
    })
  }

  cancelFetchUsers = () => {
    if (this.fetchUsersPromise && this.fetchUsersPromise.cancel) {
      this.fetchUsersPromise.cancel()
      delete this.fetchUsersPromise
    }
  }

  handleSearchInputChange = (event) => {
    this.cancelFetchUsers()

    this.setState({
      userIds: [],
      loading: false,
      loaded: false,
      cursor: null,
      keyword: event.target.value
    })
  }

  render () {
    const { ignoreUsers } = this.props
    const { userIds, loaded, loading, keyword } = this.state

    return (
      <div className={classes.kanboUserPicker}>
        <div className={classes.searchInputWrapper}>
          <FormattedMessage id='USERS_SEARCH_HINT'>
            {formattedMessage =>
              <FormControl
                autoFocus
                type='text'
                value={keyword}
                placeholder={formattedMessage}
                onChange={this.handleSearchInputChange}
              />
            }
          </FormattedMessage>
        </div>
        <Scrollbars>
          <InfiniteScroll
            key={keyword}
            isLoading={loading}
            isLoaded={loaded}
            onLoadMore={this.fetchUsers}
          >
            <UserPicker
              ref={this.setUserPickerRef}
              userIds={userIds}
              ignoreUsers={ignoreUsers}
            />
          </InfiniteScroll>
        </Scrollbars>
      </div>
    )
  }
}

export default KanBoUserPicker
